import { useEffect } from 'react';

// rrweb replays the recorded session's focus events inside the replay
// iframe, stealing real browser focus and silencing every keyboard listener
// on the page. Kick focus back out; the window blur is the only signal the
// parent document gets.
export const useReplayFocusGuard = (player: HTMLElement | null): void => {
  useEffect(() => {
    if (!player) return undefined;

    let timeout: number | undefined;

    const handleWindowBlur = () => {
      // document.activeElement settles after the blur event.
      timeout = window.setTimeout(() => {
        const active = document.activeElement;
        if (!(active instanceof HTMLElement) || !player.contains(active)) {
          return;
        }
        const focused = player.shadowRoot?.activeElement ?? active;
        if (focused instanceof HTMLElement) focused.blur();
        window.focus();
      });
    };

    window.addEventListener('blur', handleWindowBlur);
    return () => {
      window.removeEventListener('blur', handleWindowBlur);
      window.clearTimeout(timeout);
    };
  }, [player]);
};
